import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class AccountControlConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	isRegisterButtonVisible(): boolean {
		return this.configService.get((x) => x.matCoreUi.accountControl.isRegisterButtonVisible, true);
	}

	getWithdrawLayoutEnabled(): boolean {
		return this.configService.get((x) => x.coreUi.header.withdrawLayoutEnabled, false);
	}

	isAlternativeLoginEnabled(): boolean {
		return this.configService.get((x) => x.coreUi.header.alternativeLoginEnabled, false);
	}
}
